import web3NoAccount from "./web3";
import DopAbi from "./dopClaimAbi.json";
import InsuranceAbi from "./insuranceAbi.json";
import dopDynamicAbi from "./dopDynamicAbi.json";

const getContract = (abi, address, web3) => {
  const _web3 = web3;
  return new _web3.eth.Contract(abi, address);
};

export const dopContract = (address, web3) => {
  return getContract(DopAbi, address, web3);
};

export const insuranceContract = (address, web3) => {
  return getContract(InsuranceAbi, address, web3);
};

export const dopDynamicContract = (address, web3) => {
  return getContract(dopDynamicAbi, address, web3);
};
